/**
 * Utilitaires de garde de type pour sécuriser l'utilisation de unknown
 * Ces fonctions permettent de valider le type avant utilisation
 */

import { classifyError } from '@/utils/errors'
import { sentryService } from '@/services/sentry.service'

export function isRecord(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v);
}

export function isString(v: unknown): v is string {
  return typeof v === 'string';
}

export function isArray(v: unknown): v is unknown[] {
  return Array.isArray(v);
}

/**
 * Extrait un message d'erreur de manière sécurisée depuis un objet error inconnu.
 * Internally delegates to classifyError for consistent taxonomy.
 * Automatically forwards server/unknown errors to Sentry (no-op if Sentry disabled).
 */
export function extractErrorMessage(error: unknown, defaultMessage: string): string {
  const classified = classifyError(error, defaultMessage);

  // Forward high-severity errors to Sentry (no-op when VITE_SENTRY_ENABLED !== 'true')
  if (classified.kind === 'server' || classified.kind === 'unknown') {
    sentryService.captureError(classified);
  }

  return classified.message;
}
